<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="zoneDeProductionSvc"></yo-generic-datagrid-pn>
